// Uses a MutationObserver to dynamically apply cutom hex tailwind background and text
// colors, such as bg-[#ff0000] and text-[#00ff00].

const applyColors = (el) => {
  const classes = (el.getAttribute('class') || "").split(' ')
  classes.forEach((c) => {
    const hexMatch = c.match(/\#\w{6}/)
    if (!hexMatch) return

    const hex = hexMatch[0]
    if (c.startsWith('bg-')) {
      el.style.backgroundColor = hex
    }
    if (c.startsWith('text-')) {
      el.style.color = hex
    }
  })

}
const colorMonitor = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      applyColors(mutation.target)
    }
  });
})

const onNewDocument = () => {
  colorMonitor.observe(document.body, { attributes: true, subtree: true });
  document.querySelectorAll("[class*='bg-'], [class*=text-]").forEach((el) => {
    applyColors(el)
  })
}

window.addEventListener('DOMContentLoaded', onNewDocument);
window.addEventListener('turbo:load', onNewDocument);
